export default "__VITE_ASSET__CyIbLfD9__"